import Joi from '@hapi/joi';
import { UserParams } from 'types';
import validate from './validate';
import { emailRules, nameRules, userNameRules } from './utils/common';

export const schema = Joi.object<UserParams>({
  firstName: nameRules(),
  lastName: nameRules(),
  userName: userNameRules(),
  groupName: Joi.string().allow('').max(255).messages({
    'string.max': 'STRING_MAX',
  }),
  profileID: Joi.number().required().messages({
    'any.required': 'REQUIRED_FIELD',
  }),
  email: emailRules(),
  trainTypeIDs: Joi.array().items(Joi.number().required()).messages({
    'array.includesRequiredUnknowns': 'INCOMPLETE_ERROR',
  }),
});

export default function (value: UserParams) {
  return validate(schema, value, {
    allowUnknown: true,
    context: {},
  });
}
